import { NavLink, Outlet } from 'react-router-dom';
import styles from './GuideSelect.module.css';

export default function GuideSelect() {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>Select a Guide</h1>
                <p>Choose which integration guide you want to view:</p>
            </div>
            <div className={styles.tabsRow}>
                <NavLink to="/connect-guide/claude" className={({ isActive }) => isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}>
                    Claude
                </NavLink>
                <NavLink to="/connect-guide/copilot" className={({ isActive }) => isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}>
                    Copilot
                </NavLink>
                <NavLink to="/connect-guide/gpt" className={({ isActive }) => isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}>
                    GPT
                </NavLink>
            </div>
            <div className={styles.tabContent}>
                <Outlet />
            </div>
        </div>
    );
}
